function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0H1440V2289H0z",
  transform: "translate(-36 -862)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#B2B9CB",
  fillRule: "evenodd",
  d: "M79.694 25.436l47.249 22.286-60.797 18.606-47.93-24.59 61.478-16.302z",
  clipRule: "evenodd"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#95A1C2",
  fillRule: "evenodd",
  d: "M79.694 25.436v68.332l46.98 19.46.28-65.08-47.26-22.712z",
  clipRule: "evenodd"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fill: "#C0C9DC",
  fillRule: "evenodd",
  d: "M126.674 113.228l-60.638 21.687-.127-68.802 61.045-17.965-.28 65.08z",
  clipRule: "evenodd"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fill: "#DCE2F1",
  fillRule: "evenodd",
  d: "M18.344 41.87v63.753l47.692 29.292V66.113L18.344 41.869z",
  clipRule: "evenodd"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fill: "#DCE2F1",
  fillRule: "evenodd",
  d: "M18.454 42.084l61.24-16.648L66.782 10 6 25.245l12.454 16.839zM79.694 25.436L90.2 10 138 31.913l-11.046 16.235-47.26-22.712z",
  clipRule: "evenodd"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  fill: "#B2B9CB",
  fillRule: "evenodd",
  d: "M18.332 42.698L6 25.245l48.538 21.633 11.484 19.198-47.69-23.378zM66.064 66.097l12.061-18.75L138 31.912l-11.046 16.235-60.89 17.949z",
  clipRule: "evenodd"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  fill: "#DCE2F1",
  fillRule: "evenodd",
  d: "M65.909 66.113l12.216-18.767.97.958-13.186 17.809z",
  clipRule: "evenodd"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  fill: "#95A1C2",
  fillRule: "evenodd",
  d: "M78.125 47.346l.97.958 58.382-15.598.523-.793-59.875 15.433z",
  clipRule: "evenodd"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  fill: "#DCE2F1",
  fillRule: "evenodd",
  d: "M66.146 66.328l-11.608-19.45-.987.923 12.595 18.527z",
  clipRule: "evenodd"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  fill: "#95A1C2",
  fillRule: "evenodd",
  d: "M53.551 47.8l.987-.922L6 25.245l.684.971 46.867 21.585z",
  clipRule: "evenodd"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  fill: "#5B534D",
  fillRule: "evenodd",
  d: "M119.345 96.903l-.014-.35-.145.047.017.35c-1.989.715-2.148 3.241-2.148 3.241s1.015-.634 1.411-.079c0 0 .359-.385.845-.601l.119 2.726s.031.428.014.542c-.026.18-.173.165-.195.016-.017-.124-.105-.1-.119.006-.014.105.085.348.283.253.197-.095.183-.299.183-.299l-.025-.565-.116-2.736c.294-.102.622-.131.947.018 0 0 .825-.988 1.359-.717 0 0-.271-2.504-2.416-1.852z",
  clipRule: "evenodd"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  fill: "#5B534D",
  fillRule: "evenodd",
  d: "M121.046 102.84l-2.948.975c-.814.269-1.509-.306-1.549-1.282l-.152-3.54c-.043-.976.585-1.988 1.399-2.257l2.948-.975c.814-.269 1.509.307 1.552 1.282l.149 3.541c.043.976-.585 1.987-1.399 2.256zm1.773-5.97c-.057-1.323-.998-2.103-2.101-1.738l-2.951.975c-1.102.364-1.95 1.736-1.893 3.058l.15 3.542c.056 1.322.997 2.102 2.1 1.737l2.951-.975c1.102-.364 1.953-1.736 1.896-3.058l-.152-3.541zM119.316 86.084l-.008.002-.107.036.282.796.238-.239.316 1.27-.418-.941-.192.197-.404-1.026-.523.17s-.583 1.75-.368 2.676c.187.8 1.035.54 1.261.456l.082 2.151c-.325.13-.679.389-.882.55-.037.029-.023.091.017.079l1.899-.618c.04-.013.048-.081.012-.087-.207-.032-.58-.065-.916.032l-.082-2.148c.257-.076 1.051-.377 1.167-1.246.139-1.041-.562-2.373-.562-2.373l-.812.263z",
  clipRule: "evenodd"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  fill: "#5B534D",
  fillRule: "evenodd",
  d: "M122.44 89.689c.037.976-.594 1.986-1.405 2.25l-2.951.96c-.814.264-1.504-.316-1.543-1.292l-.139-3.546c-.036-.976.594-1.986 1.405-2.25l2.951-.96c.814-.264 1.507.316 1.543 1.292l.139 3.546zm-1.707-5.468l-2.948.96c-1.103.358-1.959 1.727-1.906 3.05l.136 3.546c.054 1.324.992 2.11 2.095 1.752l2.95-.96c1.1-.358 1.956-1.727 1.906-3.05l-.139-3.546c-.054-1.324-.992-2.11-2.094-1.752z",
  clipRule: "evenodd"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M108.089 68.141l-21.891 7.55.113 4.622 21.891-7.55-.113-4.622z",
  clipRule: "evenodd"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  fill: "#474646",
  fillRule: "evenodd",
  d: "M87.772 75.799l-.458.158.082 3.317.458-.158-.082-3.317zM89.573 75.177l-1.055.364.082 3.317 1.055-.363-.082-3.318zM90.576 74.832l-.401.138.082 3.317.401-.138-.082-3.317zM91.656 74.46l-.427.147.08 3.317.426-.147-.08-3.317zM93.886 73.69l-1.354.467.082 3.317 1.354-.467-.082-3.318zM94.991 73.309l-.302.104.082 3.317.302-.104-.082-3.317zM97.298 72.513l-1.806.623.081 3.317 1.807-.623-.082-3.317zM98.301 72.167l-.45.156.08 3.317.452-.156-.082-3.317zM100.209 71.51l-.904.31.081 3.318.902-.311-.079-3.317zM101.198 71.168l-.489.168.082 3.317.486-.167-.079-3.318zM103.519 70.367l-.65.225.079 3.317.653-.224-.082-3.318zM104.18 70.14l-.26.089.082 3.317.26-.09-.082-3.317zM105.978 69.52l-1.003.345.082 3.318 1.003-.346-.082-3.318zM107.032 69.156l-.35.121.079 3.317.35-.12-.079-3.318z",
  clipRule: "evenodd"
});

function SvgBox(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 145,
    height: 145,
    fill: "none",
    viewBox: "0 0 145 145",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBox);
export default __webpack_public_path__ + "static/media/box.7ac76acd.svg";
export { ForwardRef as ReactComponent };